<template>
  <BreadCrumbDetail :PageTitle="t('auth.theAccountsOf') " />
  <AccountContentByCompany />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumbDetail from "../../components/Common/BreadCrumbDetail.vue";
import AccountContentByCompany from "../../components/Financial/AccountContentByCompany.vue";


export default defineComponent({
   
  name: "UsersByCompanyPage",
  components: {
    BreadCrumbDetail,
    AccountContentByCompany,
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  }

});
</script>